module.exports = __webpack_public_path__ + "img/banner_bonapp_1018x166_.4f690422.png";